module.exports = __webpack_public_path__ + "img/1.5c7912c.jpg";